<template>
  <div class="gestion-container">
    <h2 class="mb-4">Gestión de Puntos de Abastecimiento</h2>

    <!-- Listado de Puntos de Abastecimiento -->
    <div class="card shadow-sm p-3 mb-4 bg-white rounded">
      <h5>Listado de Puntos de Abastecimiento</h5>

      <table class="table">
        <thead>
          <tr>
            <th>Nombre</th>
            <th>Ubicación</th>
            <th>Exactitud</th>
            <th>Visible</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="punto in puntosAbastecimiento" :key="punto.id">
            <td>{{ punto.nombre }}</td>
            <td>{{ formatearUbicacion(punto.ubicacion) }}</td>
            <td>{{ punto.nivel_exactitud }}</td>
            <td>{{ punto.visible ? 'Sí' : 'No' }}</td>
            <td>
              <button class="btn btn-sm btn-outline-primary me-2" @click="editarPuntoAbastecimiento(punto)"><font-awesome-icon :icon="['fas', 'pen']" />Editar</button>
              <button class="btn btn-sm btn-outline-danger" @click="eliminarPuntoAbastecimiento(punto.id)"><font-awesome-icon :icon="['fas', 'trash']" />Eliminar</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import axios from '@/axios';

export default {
  props: {
    puntosAbastecimiento: Array,  // Recibimos los puntos de abastecimiento como prop
  },
  data() {
    return {
      clubActual: this.$store.getters.getClubActual,
    };
  },
  methods: {
    formatearUbicacion(ubicacion) {
      return `${ubicacion.pais}, ${ubicacion.region}, ${ubicacion.ciudad}, ${ubicacion.distrito}`;
    },

    // Eliminar un punto de abastecimiento
    async eliminarPuntoAbastecimiento(id) {
      if (confirm('¿Está seguro de que desea eliminar este punto de abastecimiento?')) {
        try {
          await axios.delete(`/api/puntos_abastecimiento/${id}`, {data: {club_id: this.clubActual.id}});
          this.$emit('actualizar'); // Emitimos el evento para que el componente padre actualice la lista
        } catch (error) {
          console.error('Error al eliminar el punto de abastecimiento:', error);
        }
      }
    },

    // Editar un punto de abastecimiento
    editarPuntoAbastecimiento(punto) {
      this.$emit('editar', punto); // Emitimos el evento para editar en el componente padre
    },
  },
};
</script>

<style scoped>
.gestion-container {
  max-width: 900px;
  margin: 0 auto;
}

h2 {
  font-weight: bold;
  margin-bottom: 20px;
}

.card {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.table {
  margin-top: 10px;
}

.btn-outline-primary {
  border-color: var(--app-primary);
}

.btn-outline-danger {
  border-color: #dc3545;
}
</style>
